<template>
  <v-app>
    <!-- -------- -->
    <!-- Snackbar -->
    <!-- -------- -->
    <v-snackbar
      v-model="snackActivation"
      top
      :timeout="this.$store.getters.duree"
      :color="this.$store.getters.couleur"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="this.$store.getters.texte"></span>
      <v-icon dark class="pl-3" medium @click="$store.dispatch('effacer')">
        cancel
      </v-icon>
    </v-snackbar>

    <!-- ------ -->
    <!-- Entete -->
    <!-- ------ -->
    <saqEntete />

    <!-- -------------->
    <!-- Maintenance -->
    <!-- -------------->
    <v-main v-if="$maintenanceMode">
      <maintenance />
    </v-main>

    <!-- ------- -->
    <!-- Contenu -->
    <!-- ------- -->
    <v-main v-else>
      <router-view />
    </v-main>

    <!-- ----------- -->
    <!-- Bas de page -->
    <!-- ----------- -->
    <v-bottom-sheet v-model="sheet" inset>
      <template v-slot:activator="{ on, attrs }">
        <v-row align="end">
          <v-btn color="white" text dark v-bind="attrs" v-on="on">
            <v-icon color="#343232">help</v-icon>
            <a
              class="text-subtitle-1"
              style="
              text-transform: none;
              text-decoration: underline;
              color: #343232;
              padding-left: 5px;
            "
              >Support</a
            >
          </v-btn>
        </v-row>
      </template>

      <v-sheet class="text-center" height="200px">
        <div class="my-3 pt-6">
          <div class="text-center mb-0">
            Pour obtenir du support pour une commande transmise, mais non
            confirmée:
          </div>
          <div class="text-center mb-0">
            Contacter notre service de Commandes clients 514-254-8686 option 1 -
            Ailleurs au Québec 1 866 554-8686 option 1
          </div>
          <div class="text-center mb-0">
            Pour obtenir du support concernant une commande en statut confirmée
            :
          </div>
          <div class="text-center mb-0 ">
            Contacter notre service après-vente au : 514-254-8686 option 4 -
            Ailleurs au Québec 1 866 554-8686 option 4
          </div>
        </div>
        <v-btn
          class="mt-2"
          medium
          color="primary"
          style="text-transform: none;"
          @click="sheet = !sheet"
        >
          Fermer
        </v-btn>
      </v-sheet>
    </v-bottom-sheet>
  </v-app>
</template>

<script>
import i18n from '@/plugins/i18n'
import saqEntete from '@/components/Entete.vue'
import maintenance from '@/views/Maintenance.vue'
export default {
  name: 'App',
  components: {
    saqEntete,
    maintenance
  },
  data() {
    return {
      show: false,
      sheet: false
    }
  },
  computed: {
    buildTime: function() {
      return process.env.VUE_APP_BUILD_DATE
    },
    version: function() {
      return process.env.VUE_APP_VERSION
    },
    snackActivation: {
      get: function() {
        return this.$store.getters.activation
      },
      // Pour eviter des erreurs javascript..
      set: function(newValue) {}
    }
  },
  beforeMount() {
    this.$store.dispatch('effacer') // Effacer message snack
    this.$store.dispatch('resetCustomCheckout') // reset customcheckout
  }
}
</script>

<style scoped>
.footer {
  height: 45px;
  width: 2040px;
  background-color: #f2f2f2;
}
</style>
